<template>
  <div class="container">
    <div class="explained">
      <span class="h2 mb-5">How does it work?</span>
      <div class="steps">
        <art-club-explained-step
          v-for="(step, index) in steps"
          :num="index + 1"
          :key="index"
          :text="step"
        ></art-club-explained-step>
      </div>
    </div>
  </div>
</template>

<script>
import ArtClubExplainedStep from './ArtClubExplainedStep';

export default {
  name: 'ArtClubExplained',
  components: { ArtClubExplainedStep },
  data() {
    return {
      steps: [
        "Every 2 weeks you'll be provided a subject to study",
        '<a class="primary" target="_blank" rel="noreferrer" href="https://discord.gg/maddy">Join the discord</a> server to stay informed and connect with others',
        'Study one or more of the references and upload it to the study here',
        'Get live feedback on your painting and revise your study',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.explained {
  background: white;
  display: flex;
  flex-direction: column;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 8px 24px 0px rgba(black, 0.06);

  .steps {
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 1024px) {
      flex-direction: row;
    }
  }
}
</style>
